// axiosConfig.js
import axios from 'axios';
import { apiUrl } from "../constans";


const apiClient = axios.create({
  baseURL: apiUrl, // Cambia esto a la URL base de tu API
  headers: {
    "Content-Type": "application/json",
  },
});

export default apiClient;
